import { dateToMidnight } from '@main/shared/utils';

export function rangeToDates(start: string, end?: string | null): [Date, Date] {
  const firstDate = dateToMidnight(start);
  const secondDate = dateToMidnight(end || start);

  firstDate.setHours(0, 0, 0, 0);
  secondDate.setHours(23, 59, 59, 999);

  return [firstDate, secondDate];
}
